import React from 'react'
import "./footer.scss";
import { Link } from 'react-router-dom';

const RiskDisclaimer = () => {
  return (
    <div className="risk_wrp">
      <span>
        <em>Risk Disclaimer: </em>Intellitech is a technology company that
        develops, licenses, and provides algorithmic trading software. We are
        not a registered broker-dealer, investment adviser, commodity trading
        advisor, or investment fund manager We do not provide
        investment, financial, legal, or tax advice, do not manage or control
        client funds, and do not accept deposits or hold custody of client
        assets.{" "}
        <Link to={"/disclaimer"}>
          {" "}
          <span style={{ color: "#ff851b" , textDecoration:"underline"}}>Read more</span>{" "}
        </Link>
      </span>
    </div>
  );
}

export default RiskDisclaimer
